import { RightsReadWriteUtils } from '@bc-library/interface'
import { useUserStore } from '@/config/store/userStore'

type AdministrationMailUser = {
  _firmId?: string | null
  profile?: {
    modules?: {
      recruitment?: { canDecideProcessResult?: boolean }
      hr?: { accessJobPath?: string, resourceProfileAccess?: boolean }
    }
  } | null
}

export const canAccessAdministrationMail = (user: AdministrationMailUser | null | undefined) => {
  if (!user?._firmId || !user?.profile?.modules)
    return false

  const { recruitment, hr } = user.profile.modules

  if (recruitment?.canDecideProcessResult)
    return true

  return RightsReadWriteUtils.canWrite(hr?.accessJobPath) && !!hr?.resourceProfileAccess
}

export const guardAdministrationMailAccess = () => {
  const userStore = useUserStore()
  return canAccessAdministrationMail(userStore.user) ? true : { name: 'Home' }
}
